import { CollapsibleSection } from '@eng-mono/atlassian/jira/mojira-bugtracker/frontend-feature-issue-list-collapsible-section';
import { JsmIssueBase } from '@eng-mono/atlassian/jira/mojira-bugtracker/util-issue-list-fe';

import { CommentDisplay } from './comments/comments-display';

interface CommentsCollapseProps {
  issue: JsmIssueBase;
  expanded: boolean;
  toggleSection: () => void;
}

export function CommentsCollapse({
  issue,
  expanded,
  toggleSection,
}: CommentsCollapseProps) {
  return (
    <CollapsibleSection
      title="Comments"
      expanded={expanded}
      setExpanded={toggleSection}
    >
      <CommentDisplay issueKey={issue.key} />
    </CollapsibleSection>
  );
}
